

import { useState, useMemo } from 'react';
import { searchableItems, SearchableItem } from '../data/searchableItems';



export const useSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const searchResults = useMemo(() => {
    if (!searchTerm.trim()) return { navegacao: [] };

    const term = searchTerm.toLowerCase();

    // Buscar apenas páginas e configurações navegáveis
    const navegacao = searchableItems.filter((item: SearchableItem) => {
      const titleMatch = item.title.toLowerCase().includes(term);
      const descriptionMatch = item.description.toLowerCase().includes(term);
      const keywordsMatch = item.keywords.some(keyword => keyword.toLowerCase().includes(term));

      return titleMatch || descriptionMatch || keywordsMatch;
    });

    return { navegacao };
  }, [searchTerm]);

  return {
    searchTerm,
    setSearchTerm,
    searchResults,
    hasResults: searchResults.navegacao.length > 0
  };
};
